export class ServicesSkillsQualificationsModel {
  qualificationsOther: string[] = [];
  ServicesSkills: string[] = [];

  medicationAdministrationservices: boolean;
  planToOfferHygieneServices: boolean;
}
